<template lang="pug">
  div
    div
      el-form-item(:label="$t('studymode')")
        el-radio-group(v-model='distant', @change="distantChanged")
          el-radio(label='nonDistant') {{$t("conventional")}}
          el-radio(label='distant') {{$t("distance")}}
        el-tooltip(placement='right')
          div(slot='content')
            | <p v-html="$t('hint_typeof_studies')"></p>
          i.el-icon-question
    div
      el-form-item(label=' ', v-show="distant === 'nonDistant'")
        el-radio-group(v-model='partTime', @change="partTimeChanged")
          el-radio(label='fixed') {{$t("fulltime")}}
          el-radio(label='partial') {{$t("parttime")}}
        el-tooltip(placement='right')
          div(slot='content')
            | <p v-html="$t('hint_regular_partial')"></p>
          i.el-icon-question
      div(v-show="distant === 'distant'")
        el-form-item(label=' ')
          el-checkbox(label='Μέρος έγινε στην Ελλάδα', name='title.partOfStudiesGr',
          v-model='title.partOfStudiesGr', @change="partOfStudiesGrChanged")
          el-tooltip(placement='right')
            div(slot='content')
              span {{ $t("hint_partial_gr") }}
            i.el-icon-question
        //- el-form-item(label='Πόλη', v-show='title.partOfStudiesGr', prop="test")
        //-   el-input(v-model='title.cityOfStudiesGr',  @change="fieldChanged",
        //-   @input="title.cityOfStudiesGr = title.cityOfStudiesGr.toUpperCase()")
        el-form-item(:label="$t('city')", v-show='title.partOfStudiesGr',
          :prop="fromConsideration ? 'cityOfStudiesGr' : 'titles.cityOfStudiesGr'")
          el-input(v-model='title.cityOfStudiesGr',  @change="fieldChanged",
          @input="title.cityOfStudiesGr = title.cityOfStudiesGr.toUpperCase()")
        el-form-item(:label="$t('institution')", v-show='title.partOfStudiesGr',
          :prop="fromConsideration ? 'institutionOfStudiesGr' : 'titles.institutionOfStudiesGr'")
          el-input.biggest(v-model='title.institutionOfStudiesGr',  @change="fieldChanged",
            @input="title.institutionOfStudiesGr = title.institutionOfStudiesGr.toUpperCase()")
</template>

<script>
export default {
  data() {
    return {
    }
  },
  mounted() {
    if (this.title.distant === null) {
      this.title.distant = false
    }
    if (this.title.partTime === null) {
      this.title.partTime = false
    }
  },
  props: ['title', 'applicationFinalSaved', 'fromConsideration'],
  computed: {
    distant: {
      get: function() {
        if (this.title.distant === null) {
          this.distantDefault()
          return 'nonDistant'
        } else {
          return this.title.distant ? 'distant' : 'nonDistant'
        }
      },
      set: function(val) {
        this.distantChanged(val)
      },
    },
    partTime: {
      get: function() {
        if (this.title.partTime === null) {
          this.partTimeDefault()
          return 'fixed'
        } else {
          return this.title.partTime ? 'partial' : 'fixed'
        }
        // return this.title.partTime === null
        //   ? 'fixed' : this.title.partTime ? 'partial' : 'fixed'
      },
      set: function(val) {
        this.partTimeChanged(val)
      },
    },
  },
  methods: {
    fieldChanged(el) {
      this.$emit('typeOfStudyChanged', this.title)
    },
    partTimeChanged(type) {
      this.title.partTime = type === 'partial'
      this.$emit('typeOfStudyChanged', this.title)
    },
    distantDefault() {
      this.title.distant = false
    },
    partTimeDefault() {
      this.title.partTime = false
    },
    partOfStudiesGrChanged() {
      this.title.cityOfStudiesGr = ''
      this.title.institutionOfStudiesGr = ''
      this.fieldChanged()
    },
    distantChanged(type) {
      this.title.distant = type === 'distant'
      type === 'distant'
        ? (this.title.partOfStudiesGr = false)
        : (this.title.partOfStudiesGr = null)
      this.$emit('typeOfStudyChanged', this.title)
    },
  },
  watch: {},
}
</script>

<style lang="scss" scoped></style>
